<template>
  <svg :class="customClasses || 'text-primary'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <rect width="14" height="14" rx="4" fill="none"/>
    <path d="M8.254,9.7,5,6.446,1.746,9.7A1.023,1.023,0,0,1,.3,8.254L3.554,5,.3,1.746A1.023,1.023,0,0,1,1.746.3L5,3.554,8.254.3A1.023,1.023,0,0,1,9.7,1.746L6.446,5,9.7,8.254A1.023,1.023,0,1,1,8.254,9.7Z" transform="translate(2 2)" class="fill-current"/>
  </svg>
</template>

<script>
export default {
    props: {
        customClasses: String,
    },
};
</script>

